import {
  ImageMax,
  getStoryBlokImage,
} from "apps/website/utils/storyblok/image";
import Image from "apps/website/components/base/Image/Image";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import {
  IStoryBlokImage,
  IStoryBlokComponent,
} from "apps/website/components/page/api.types";

export interface IStoryBlokArticleImage {
  image: IStoryBlokImage;
  caption?: string;
}

export const StoryBlokArticleImage = ({ blok }: IStoryBlokComponent<IStoryBlokArticleImage>) => {
  const caption = blok.caption?.trim();
  return (
    <>
      <figure>
        <Image image={{ ...getStoryBlokImage(blok.image, true, ImageMax.CONTAINER_XL) }} alt={blok.image.alt} />
        { caption ? (
          <>
            <Spacer customSize="h-2" />
            <TextBody tag="figcaption" size={3} className="text-foreground-muted">
              { caption }
            </TextBody>
          </>
        ) : null }
      </figure>
      <Spacer size="lg" />
    </>
  );
};
